import { SendAuthMailRequest } from './service-models/send-auth-mail/SendAuthMailRequest';
import { SendAuthMailResult } from './service-models/send-auth-mail/SendAuthMailResult';
import { AuthConfirmRequest } from './service-models/auth-confirm/AuthConfirmRequest';
import { AuthConfirmResult } from './service-models/auth-confirm/AuthConfirmResult';
import { BaseService } from './BaseService';
import { WprBaseViewCore } from '../wpr-framework/view/WprBaseViewCore';

/**
 * 認証メール情報登録・取得サービス
 */
export class MailAuthService extends BaseService {
	// サービス メソッド  -----------------------------------------------------------------------------------------------------------------------------
	/**
	 * メール送信処理
	 * @param viewCore ビュー情報 
	 * @param request リクエスト情報
	 * @param resMethod 結果処理メソッド
	 */
	public sendAuthMail(viewCore: WprBaseViewCore, request: SendAuthMailRequest, resMethod: (result: SendAuthMailResult) => void): void {
		return this.doPost(viewCore, '/mailauth/send', request, resMethod);
	}

	/**
	 * 認証メール情報取得処理
	 * @param viewCore ビュー情報
	 * @param request リクエスト情報
	 * @param resMethod 結果処置メソッド
	 */
	public mailAuthentication(viewCore: WprBaseViewCore, request: AuthConfirmRequest, resMethod: (result: AuthConfirmResult) => void): void {
		return this.doPost(viewCore, '/mailauth/auth', request, resMethod);
	}
	// -----------------------------------------------------------------------------------------------------------------------------------------------
}